<template>
  <NuxtLayout name="default">
    <div id="error-page" class="bg-gray-20">
      <error404 v-if="is404" />
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
enum ErrorType {
  NOT_FOUND = '404',
  // ServerError = '500',
}

const Error404 = defineAsyncComponent(() => dynamicImport(() => import('@/components/common/error-404.vue'), 'error-404'))

// TODO: 未來有支援更多種錯誤頁時，要改成從 error 取得
// const error = useError()
// const errorType = computed(() => error.value.statusCode)
const errorType = computed(() => ErrorType.NOT_FOUND)

const is404 = computed(() => errorType.value === ErrorType.NOT_FOUND)
</script>

<style lang="scss" scoped>
#error-page {
  min-height: var(--content-min-height);
}
</style>
